/*
 * @description:
 * @Author: wxy
 * @Date: 2020-02-09 17:16:13
 */
import '@/styles/index.scss' // global css
import { Button, Card, Col, Message, Row } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
Vue.use(Button)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.prototype.$message = Message;
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
